
import LoaderRegistration from "../../views/admin/LoaderRegisteration";
import EarningsPage from "../../views/admin/VendorForm/Earnings";
import OrderDetail from "../../views/admin/VendorForm/OrderDetail";
import VendorDetailPage from "../../views/admin/VendorForm/VendorDetail";
import VendorForm from "../../views/admin/VendorForm/vendorForm";


const VendorRoutes = [
  {
    path: "/vendor",
    component: <VendorForm />
  },
   {
    path: "/earnings",
    component: <EarningsPage />
  },
  {
    path: "/vendor-detail",
    component: <VendorDetailPage />
  },
   {
    path: "/order-detail",
    component: <OrderDetail />
  },
  
  
];

export default VendorRoutes;